"use strict";

exports.__esModule = true;
exports.ONBOARDING = exports.OMNI_HERCULES = void 0;
var OMNI_HERCULES = exports.OMNI_HERCULES = 'OMNI_HERCULES';
var ONBOARDING = exports.ONBOARDING = 'ONBOARDING';